<template>
	<section class="select-section">
		<el-dialog :visible.sync="dialogVisible" width="70%" center
			style='min-width: 700px;'>
			<p slot="title">{{title}}</p>
			<input placeholder="" v-model="copyVal"
				id='copyVal_source' class='falseHidden'>
				<el-table :data="tableData" class="table_list" ref='table'
				 style="width: 100%" border max-height="500"
					@expand-change='changeTable2' highlight-current-row>
					<!-- <el-table-column type="expand">
						<template slot-scope="props">
							<el-form label-position="right" inline class="table-expand" label-width="150px"
							 v-if='props.row.type==1||props.row.type==4'>
								<el-form-item label="到课人数">
									<span>{{props.row.attendCount===undefined?
									'请稍后...':props.row.attendCount}}</span>
								</el-form-item>
								<el-form-item label="最高在线人数">
									<span>
									{{props.row.maxOnlineCount===undefined?
									'请稍后...':props.row.maxOnlineCount}}</span>
								</el-form-item>
								<el-form-item label="回顾人数">
									<span>
									{{props.row.reviewCount===undefined?
									'请稍后...':props.row.reviewCount}}</span>
								</el-form-item>
								<el-form-item label="报名人数">
									<span>
									{{props.row.signCount===undefined?
									'请稍后...':props.row.signCount}}</span>
								</el-form-item>
								<el-form-item style='width:100%;' label="统计时间">
									<span>{{$moment(props.row.planStartTime).add(-2,'hours').format('YYYY-MM-DD HH:mm:ss')}}</span>~
									<span>{{$moment(props.row.planEndTime).add(2,'hours').format('YYYY-MM-DD HH:mm:ss')}}</span>
								</el-form-item>
							</el-form>
							<p v-else>本数据仅支持直播类型及直播转视频类型</p>
						</template>
					</el-table-column> -->
					<el-table-column prop="title" label="课程源名称" min-width="15%">
					</el-table-column>
					<el-table-column label="类型" min-width="10%">
						<template slot-scope="scope">
								<span>{{scope.row.type | typeFilter}}</span>
						</template>
					</el-table-column>
					<el-table-column prop="teacherName" label="主讲老师" min-width="15%">
					</el-table-column>
					<el-table-column label="开课时间" min-width="15%">
						<template slot-scope="scope">
							<div>{{scope.row.planStartTime}}</div>
							<div>{{scope.row.planEndTime}}</div>
						</template>
					</el-table-column>
					<el-table-column prop="createTime" label="添加时间" min-width="15%">
					</el-table-column>
					<el-table-column prop="createBy" label="添加人" min-width="15%">
					</el-table-column>
					<el-table-column label="操作" min-width="10%">
						<template slot-scope="scope">
							<el-dropdown>
								<el-button type="primary" size='small'>
								操作<i class="el-icon-arrow-down el-icon--right"></i>
								</el-button>
								<el-dropdown-menu slot="dropdown" class="table_dropdown">
									<el-dropdown-item
									 @click.native='goCourseSourceRouter(scope.row.id)'>
									查看课程源</el-dropdown-item>
									<el-dropdown-item 
									 @click.native='goLiveRouter(scope.row)'>
									进入直播</el-dropdown-item>
									<el-dropdown-item v-if='scope.row.type==1'
									 @click.native='goLiveDataRouter(scope.row)'>
									直播数据统计</el-dropdown-item>
									<!-- <el-dropdown-item v-if='scope.row.type==1'
									 @click.native='getStream(scope.row)'>
									查看流地址</el-dropdown-item> -->
									<el-dropdown-item @click.native="copyVideoUrl(scope.row)"
									 v-if='scope.row.videoURL'>复制视频链接</el-dropdown-item>
									<el-dropdown-item v-if='scope.row.type==1'
									 @click.native='resetLive(scope.row.id)'>
									重置课堂</el-dropdown-item>
									<el-dropdown-item @click.native="goExport(scope.row)">导出聊天记录</el-dropdown-item>
									<!-- <el-dropdown-item v-if='scope.row.type==1&&scope.row.managerId==USERID'
									 @click.native='sendMsg'>
									群发短信</el-dropdown-item> -->
								</el-dropdown-menu>
							</el-dropdown>
						</template>
					 <!--  <template slot-scope="scope">
						 <el-button type="text"
							@click='goCourseSourceRouter(scope.row.id)'>查看</el-button>
						 <el-button type="text"
							@click='goLiveRouter(scope.row)'>进入直播</el-button>
					 </template> -->
					</el-table-column>
				</el-table>
				<span slot="footer" class="dialog-footer">
					<el-button @click="dialogVisible = false">知道了</el-button>
				</span>
		</el-dialog>
	</section>
</template>

<script scoped>
	import {mapGetters} from 'vuex'
	import pageRouter from "@/utils/pageRouter"
	import docCourseApi from '@/api/contentManage/docCourseManage'
	import commonApi from '@/api/common'
	export default {
		name: "courseRelate",
		data() {
			return {
				commonUrl: commonApi.commonUrl,
				id: '',
				title: '',
				copyVal: '',
				choiceCourse: [],
				dialogVisible: false,
				tableData: [],
				courseSourceTab: {
					code: "courseSourceEdit",
					name: "编辑课程源",
					root: "contentManage"
				},
				liveTab: {
					code: "liveRoom",
					name: "课堂现场",
					root: "contentManage"            
				},
			}
		},
		mounted() {
			this.courseSourceRouter()
			this.liveRouter()
		},    
		computed: {
				...mapGetters('user', {
						USERID: 'userId',
						USERNAME: 'userName'
				})
		},
		methods: {
				// 课程源
				courseSourceRouter() {
					pageRouter(this, "courseSourceEdit",
					 "contentManage/courseSourceManage/courseSourceEdit")
							.catch(res => {
								this.$message.error('编辑课程路由添加失败！')
							})
				},
				// 直播        
				liveRouter() {
					pageRouter(this, "liveRoom",
					 "contentManage/liveRoom/index")
							.catch(res => {
								this.$message.error('课堂现场路由添加失败！')
							})
				},
				// 去课程源
				goCourseSourceRouter(id) {
					this.close()
					this.courseSourceTab.data = {params: {id: id}}
					this.$store.dispatch("tabs/switchTab_single",
					this.courseSourceTab)
				},
				// 进入直播
				goLiveRouter(row){
					this.close()
					
					if(row.rtmpType == 6){ //620新直播
						window.open(this.commonUrl.liveUrl + '/live?sid=' + row.id, 'live')
					}else{
						this.liveTab.data = {params: {courseSourceData: row}}
						this.$store.dispatch("tabs/switchTab_single",
						this.liveTab)
					}
				},
				// 直播数据统计
				goLiveDataRouter(row) {
					window.open(this.commonUrl.liveUrl + '/data/' + row.id, 'data')
				},
				// 查看流地址
				getStream() {

				},
				open(title,id) {
					this.id = id;
					this.dialogVisible = true;
					this.title = title;
					this.getData(id)
				},
				close() {
					this.tableData = []
					this.dialogVisible = false;
				},
				/*展开二级表格*/
				changeTable2(row, expandedRows) {
						if(!(row.type==1||row.type==4)){return;}
						if(!row.isOpen){
								row.isOpen = true;
								// 无开课时间
								if(!row.planStartTime||!row.planEndTime){
										this.$message.warning('开课时间缺失，无法查询！');
										return;
								}
								Promise.all([this.getSignCount(row),this.getMembers(row),
									this.getOnlineMax(row),this.getReviewCount(row)]).then(
									(result)=>{
										row.signCount = result[0]
										row.attendCount = result[1]
										row.maxOnlineCount = result[2]
										row.reviewCount = result[3]
										this.$refs.table.setCurrentRow(row)
									}).catch((error) => {
										console.log(error)
									})
						}else{
								row.isOpen = false;
						}
				},
				// 获取报名人数
				getSignCount(row) {
					return new Promise((resolve,reject) => {
						let data = {
							courseId: this.id,
							// endTime: row.planEndTime,
							endTime: this.$moment(row.planEndTime).add(2,'hours')
								.format('YYYY-MM-DD HH:mm:ss')
						}
						docCourseApi.getCourseBaoming(data).then(res => {
							if(res.Success) {
									resolve(res.Data)
							}else{
									this.$message.error(res.Msg);
							}
						}).catch(res => {
								this.$message.error('获取数据出错，请稍后再试！')
						})            
					})
				},
				// 获取到课人数
				getMembers(row) {
					return new Promise((resolve,reject) => {
						let data = {
							courseId: this.id,
							sourceId: row.id,
							/*start: new Date(row.planStartTime).getTime(),
							end: new Date(row.planEndTime).getTime()*/
							start: new Date(this.$moment(row.planStartTime).add(-2,'hours')
								.format('YYYY-MM-DD HH:mm:ss')).getTime(),
							end: new Date(this.$moment(row.planEndTime).add(2,'hours')
								.format('YYYY-MM-DD HH:mm:ss')).getTime()
						}
						docCourseApi.getCourseDaoKe(data).then(res => {
							if(res.Success) {
									resolve(res.Data)
									// console.log(row)
							}else{
									this.$message.error(res.Msg);
							}
						}).catch(res => {
								this.$message.error('获取数据出错，请稍后再试！')
						})
					})
				},
				// 获取最高在线
				getOnlineMax(row) {
					return new Promise((resolve,reject) => {
						let data = {
							courseId: this.id,
							sourceId: row.id,
							/*start: new Date(row.planStartTime).getTime(),
							end: new Date(row.planEndTime).getTime()*/
							start: new Date(this.$moment(row.planStartTime).add(-2,'hours')
								.format('YYYY-MM-DD HH:mm:ss')).getTime(),
							end: new Date(this.$moment(row.planEndTime).add(2,'hours')
								.format('YYYY-MM-DD HH:mm:ss')).getTime()
						}
						docCourseApi.getCourseZaixian(data).then(res => {
							if(res.Success) {
									resolve(res.Data)
							}else{
									this.$message.error(res.Msg);
							}
						}).catch(res => {
								this.$message.error('获取数据出错，请稍后再试！')
						})
					})
				},
				// 获取回顾人数
				getReviewCount(row) {
					return new Promise((resolve,reject) => {
						let data = {
							courseId: this.id,
							sourceId: row.id,
							/*start: new Date(row.planStartTime).getTime(),
							end: new Date(row.planEndTime).getTime()*/
							start: new Date(this.$moment(row.planStartTime).add(-2,'hours')
								.format('YYYY-MM-DD HH:mm:ss')).getTime(),
							end: new Date(this.$moment(row.planEndTime).add(2,'hours')
								.format('YYYY-MM-DD HH:mm:ss')).getTime()
						}
						docCourseApi.getCourseHuigu(data).then(res => {
							if(res.Success) {
									resolve(res.Data)
							}else{
									this.$message.error(res.Msg);
							}
						}).catch(res => {
								this.$message.error('获取数据出错，请稍后再试！')
						})
					})
				},
				rowClickHandle(row) {
						var index = this.choiceCourse.indexOf(row)
						if(index == -1){
								this.choiceCourse.push(row)
						}else{
								this.choiceCourse.splice(index,1)
						}
				},
				getData(id) {
					if(!id){ return }
					var params = {
						courseId: id
					};
					docCourseApi.getCourseRelate(params).then(res => {
						if (res.Success) {
								for(let i = 0; i < res.Data.length; i++){
										res.Data[i].index = i;
								}
								this.tableData = res.Data
						} else {
							this.$message.error(res.Msg);
						}
					}).catch(res => {
						this.$message.error('关联课程源获取出错，请刷新重试！')
					})
				},
				// 重置课堂
				resetLive(id) {
					this.$confirm('重置后将恢复到未直播状态！', '重置课堂', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						docCourseApi.resetLive({sourceId: id}).then(res => {
							if(res.Success){
									this.$message.success('重置成功！')
							}else{
									this.$message.error(res.Msg)
							}
						}).catch(res =>{
							this.$message.error('重置失败，请稍后再试！')
						})
					}).catch(() => {})
				},
				// 复制视频链接
				copyVideoUrl(data){
						this.copyVal = data.videoURL;
						let timer = setTimeout(() => {
							clearTimeout(timer)
							let configUrl = document.getElementById('copyVal_source');
							configUrl.select();
							try{
								if(document.execCommand('copy')){
									this.$message.success('复制成功！');
								}else{
									this.$message.warning('复制失败！')
								}              
							} catch (err){
								console.log(err)
								this.$message.warning('复制失败！')
							}

						},500)
				},
				// 导出聊天记录
				goExport(data) {
					pageRouter(
						this,
						"exportChatFile",
						"contentManage/docCourseManage/exportChatFile"
						).then(() => {
							var tab = {
								code: "exportChatFile",
								name: "直播聊天记录",
								root: "contentManage",
								data: {
									params: {
										courseId: this.id,
										sourceId: data.id
									}
								}
							};
							this.close()
							//改变tab
							this.$store.dispatch("tabs/switchTab_single", tab);
					});
				}
		},
		filters: {  
			typeFilter(value) {
				let text = ''
				switch(value){
					case 1: text = '直播'; break;
					case 2: text = '视频'; break;
					case 3: text = '线下'; break;
					case 4: text = '直播转视频'; break;
					case 5: text = '课件'; break;
					case 6: text = '网页'; break;
					case 10: text = '评测'; break;
					default: break;
				}
				return text
			}
		}
};
</script>

<style type="text/less" lang="less" scoped>
.select-section {
	.el-dialog__wrapper {
		background-color: rgba(0, 0, 0, 0.1);
	}
	.pagination-wrap {
		margin-top: 10px;
	}
	.el-pagination {
		float: right;
	}
	.dialog-footer {
		margin-top: 40px;
	}
}
.search-row {
	margin-bottom: 10px;
	.input-with-select {
		width: 30%;
	}
	.search-select {
		width: 120px;
	}
}
.search-row>div{
		margin: 5px 5px 5px 0;
		max-width: 270px;
}
.table-expand .el-form-item {
		margin-right: 0;
		margin-bottom: 0;
		width: 49%;
		float: left;
		text-align: left;
}
.falseHidden{
		position: absolute;
		// height: 0;
		border: none;
		padding: 0;
}
</style>


// WEBPACK FOOTER //
// src/views/contentManage/docCourseManage/relateCourseSource.vue